export default __webpack_public_path__ + "static/media/illustration-reset.c5f36c0c.jpg";